import { render, staticRenderFns } from "./manage-list.vue?vue&type=template&id=e151f44c"
import script from "./manage-list.vue?vue&type=script&lang=js"
export * from "./manage-list.vue?vue&type=script&lang=js"
import style0 from "./manage-list.vue?vue&type=style&index=0&id=e151f44c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports